import { graphql } from 'gatsby';
import React from 'react';
import SplitHero from './split-hero';
import FullWidthHero from './full-width-hero';

export type HeroProps = {
    hasLocationWidget?: boolean | null
    fullwidthBackground?: boolean | null
    heading?: string | null
    subheading?: string | null
    copy?: string | null
    buttonLink?: ContentStackLink | null
    buttonLink2?: ContentStackLink | null
    image?: ContentStackImage | null
    alignment?: string | null
};

const Hero = (props: HeroProps): JSX.Element => {
    const { fullwidthBackground } = props;
    if (fullwidthBackground) {
        return <FullWidthHero {...props} />;
    }

    return <SplitHero {...props} />;
};
export const query = graphql`
    fragment HeroData on CsHero {
        ... on CsHero {
            hasLocationWidget
            fullwidthBackground
            heading
            subheading
            copy
            buttonLink {
                href
                title
            }
            buttonLink2 {
                href
                title
            }
            image {
                filename
                title
                description
                url
                contentStackAsset(width: 1440)
            }
            alignment
            media {
              ...MediaDataFragment
            }
        }
    }
`;

export default Hero;
